import type { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/constants';

export interface Profile {
  authorId: string;
  username: string;
  nickname?: string;
  profileImageUrl: string;
  followerCount: number;
  postCount: number;
  totalLikes: number;
  totalComments: number;
  totalShares: number;
  totalViews: number;
  platform: SOURCE_PLATFORM_TYPE;
}

export interface ExtendedProfile extends Profile {
  engagementRate: number;
}

export interface Location {
  name: string;
  code: string;
  postCount: number;
  totalLikes: number;
  totalComments: number;
  totalShares: number;
  totalViews: number;
}

export interface DemographicStat {
  name: string;
  postCount: number;
  totalLikes: number;
  totalComments: number;
  totalShares: number;
  totalViews: number;
}

export interface Theme {
  type: Sentiment;
  name: string;
  volume: number;
  volumeRatio: number;
  brand: string;
  product: string;
}

export interface Keyword {
  name: string;
  post_volume: number;
}

export interface Hashtag {
  name: string;
  post_volume: number;
}

export interface Product {
  name: string;
  subname: string;
  count: number;
}

export interface Brand {
  name: string;
  count: number;
}

export enum Sentiment {
  Positive = 'positive',
  Negative = 'negative',
}

export enum PostFilter {
  Theme = 'theme',
  Brand = 'brand',
  Product = 'product',
  Keyword = 'keyword',
  Hashtag = 'hashtag',
  Profile = 'profile',
  Sentiment = 'sentiment',
  Dimension = 'dimension',
}

export type PostFilterMap = { [key in PostFilter]?: string };

// Theme table tab type for filtering
export type ThemeTabType = 'all' | 'positive' | 'negative';
